import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="text-2xl" role="img" aria-label="logo">🌸</span>
              <span className="text-lg font-heading font-bold text-foreground-50">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.tagline} —— 一站式动漫、电视剧、电影在线观看平台，海量资源免费畅享。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/recent" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/japanese" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  日本动漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@yinghuadm.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                <span>在线客服：7x24小时</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 {siteConfig.name}. 本站资源仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}